<prime-dialog [visible]="visible()" [headerRef]="true" [breakpoints]="breakpoints()" (onCloseButton)="onClose()">
  <header class="flex-grow-1" dialog-title>
    <h1 class="font-bold text-center p-3">
      Aviso de Privacidad
    </h1>
  </header>
  <div dialog-body class="px-3">
    <app-privacy-notice />
  </div>
</prime-dialog>
